import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import './Navbar.css';
import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import Logo from '../assets/gorion.png';
import UserIcon from '../assets/user.png'; // Ícono genérico para el usuario

const Navbar = () => {
  // Obtener el token desde Redux
  const token = useSelector((state) => state.auth.token);
  //console.log('Token obtenido desde Redux en Navbar:', token);

  const [user, setUser] = useState(null);
  const [isDropdownVisible, setIsDropdownVisible] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  // Decodificar el JWT y obtener la información del usuario
  useEffect(() => {
    const fetchUser = async () => {
      if (!token) {
        console.error('Token no encontrado en Redux.');
        return;
      }
      try {
        const decoded = jwtDecode(token);
        console.log('Payload del token decodificado:', decoded);

        const noColaborador = decoded.id;
        console.log('noColaborador extraído del token:', noColaborador);

        const response = await axios.get(`https://orionadministracion.com/api/colaboradores/${noColaborador}`, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setUser(response.data);
      } catch (error) {
        console.error('Error al obtener la información del usuario:', error);
      }
    };

    fetchUser();
  }, [token]);

  const toggleDropdown = () => {
    setIsDropdownVisible(!isDropdownVisible);
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Sección Izquierda: Logo */}
        <div className="navbar-left">
          <img src={Logo} alt="ORION Logo" className="navbar-logo" />
        </div>

        {/* Sección Central: Menú desplegable */}
        <div className="navbar-center">
          <button className="hamburger" onClick={toggleMenu}>
            &#9776;
          </button>
          {isMenuOpen && (
            <div className="navbar-menu">
              <a href="/bitacora" className="menu-item">Bitacora</a>
              <a href="/servicios" className="menu-item">Salidas</a>
              <a href="/llegadas" className="menu-item">Llegadas</a>
              <a href="/gestion" className="menu-item">Gestion</a>
              <a href="/manual" className="menu-item">Manual</a>
            </div>
          )}
        </div>

        {/* Sección Derecha: Ícono de Usuario */}
        <div className="navbar-right">
          <div className="navbar-user" onClick={toggleDropdown}>
            <img src={UserIcon} alt="User Icon" className="user-icon" />
          </div>
          {isDropdownVisible && user && (
            <div className="dropdown-user">
              <div className="dropdown-header">
                <img
                  src={`https://app.orionadministracion.com${user.fotoPerfil}`}
                  alt="User Avatar"
                  className="dropdown-avatar"
                />
                <span>{user.nombre} {user.apellidos}</span>
              </div>
              <div className="dropdown-details">
                <p><strong>Estación:</strong> {user.estacion}</p>
                <p><strong>Área:</strong> {user.area}</p>
                <p><strong>Puesto:</strong> {user.puesto}</p>
              </div>
            </div>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
